import React, { FC } from 'react';
import { BasicInfos as BasicInfosTemplate } from '@jbc-year-end-adj/2024/features/questions/templates/BasicInfos';
import { Question } from '@jbc-year-end-adj/2024/features/questions/types';
import { ButtonContainer as Buttons } from '@jbc-year-end-adj/2024/features/questions/components/ButtonContainer/ButtonContainer';
import { useEmployeeMutation } from '@jbc-year-end-adj/2024/hooks/graphql/useMutation';
import Button from 'jbc-front/components/Button';
import useReactRouter from 'use-react-router';
import { useForm, FormProvider, SubmitHandler } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { schema, generateDefaultValues } from './schema';
import { ANSWER_BASIC_INFOS } from './mutation';
import { ResidentCard } from './ResidentCard';
import { Schema } from './schema';
import { BasicInfoForm } from './BasicInfoForm';
import { Profile } from './query';

interface BasicInfosProps {
  profile: Profile;
  question: Question;
}

export const Form: FC<BasicInfosProps> = ({ profile, question }) => {
  const methods = useForm<Schema>({
    defaultValues: generateDefaultValues(profile),
    resolver: yupResolver(schema)
  });
  const { handleSubmit } = methods;
  const [answer] = useEmployeeMutation(ANSWER_BASIC_INFOS);
  const { history } = useReactRouter();

  const onSubmit: SubmitHandler<Schema> = async data => {
    const isDisasterSuffer = data.basicInfos.isDisasterSufferer === 'disasterSufferer';
    const { residentCard, basicInfos } = data;
    const modifiedBasicInfosValues = {
      ...basicInfos,
      isDisasterSufferer: isDisasterSuffer,
      taxPostponementAmount: basicInfos.taxPostponementAmount || '0'
    };
    await answer({
      variables: {
        input: {
          attributes: {
            basicInfos: modifiedBasicInfosValues,
            residentCard: residentCard
          }
        }
      }
    });
    history.push('/employee_input');
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <BasicInfosTemplate question={question}>
          <BasicInfoForm />
          <ResidentCard />
          <Buttons>
            <Button primary onClick={handleSubmit(onSubmit)}>
              次へ
            </Button>
          </Buttons>
        </BasicInfosTemplate>
      </form>
    </FormProvider>
  );
};
